import { PlainSearchParameters } from 'algoliasearch-helper'
import { SearchOptions } from 'instantsearch.js'

import { getIndexName } from '@app-lib/search-index.lib'
import { DebtorService } from '@app-services/debtor/debtor.service'
import { LocalizationService } from '@app-domains/localization/service/localization.service'
import { mapInstantSearchRequest } from '@app-domains/meilisearch/mappers/search-request.mapper'
import { MAX_SELECTED_PRODUCTS_COUNT, ProductEanBrowseSource } from '@app-domains/meilisearch/meilisearch.tokens'
import { ProductSearchGatewayService } from '@app-domains/meilisearch/services/product-search-gateway.service'

const EAN_BROWSE_PAGE_SIZE = 100

export class MeilisearchEanSource implements ProductEanBrowseSource {
    constructor(
        private readonly gateway: ProductSearchGatewayService,
        private readonly localization: LocalizationService,
        private readonly debtorService: DebtorService,
    ) {
    }

    public async browseMatchingEans(
        search: SearchOptions,
        onEan: (ean: string) => void,
        maxSelectedProductsCount?: number,
    ): Promise<void> {
        const max = maxSelectedProductsCount ?? MAX_SELECTED_PRODUCTS_COUNT
        const indexName = getIndexName({
            locale: this.localization.getCurrentLocale(),
            sorting: null,
        })
        const isNlMarket = this.debtorService.isNL.getValue()
        let page = 1
        let count = 0

        while (count < max) {
            const input = mapInstantSearchRequest(indexName, {
                ...(search as PlainSearchParameters),
                page: page - 1,
                hitsPerPage: EAN_BROWSE_PAGE_SIZE,
            }, isNlMarket)

            const result = await this.gateway.search(input)

            for (const hit of result.hits) {
                if (count >= max) {
                    break
                }

                onEan(hit.ean)
                count += 1
            }

            if (page >= result.totalPages || result.hits.length === 0) {
                break
            }

            page += 1
        }
    }
}
